import React, { useState, useEffect } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  BoxContainer,
  BoxHead,
  BoxTitle,
  Underline,
} from "../../Components/Styles/PageStyles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import { InputGroup, Label } from "../../Components/Styles/InputStyles";
import Images from "../../Images";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TbArrowBackUp } from "react-icons/tb";
import { capitalizeFirstLetter } from "../../helpers";
import { IoChevronBackOutline } from "react-icons/io5";
import tw from "tailwind-styled-components";

const localizer = momentLocalizer(moment);
const CustomToolbar = ({ label }) => {
  return (
    <div className="rbc-toolbar flex justify-center py-2 text-lg font-semibold">
      {label}
    </div>
  );
};
const TenantAttendance = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tenantName, setTenantName] = useState("");

  useEffect(() => {
    if (location.state && location.state.tenantName) {
      setTenantName(location.state.tenantName);
    }
  }, [location]);
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [apiData, setApiData] = useState([]);
  const { tenantId } = useParams();
  const [calendarOpen, setCalendarOpen] = useState(false);
  const month = moment(selectedDate).month() + 1;
  const year = moment(selectedDate).year();
  const query = `m=${month}&y=${year}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list/attendance/${tenantId}?${query}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      const formattedData = res.data.map((item) => ({
        title: item.attendance === 1 ? "Present" : "Absent",

        start: moment(item.attendanceDate).toDate(),
        allDay: true,
        tooltip: `Property: ${item.propName || "-"}`,
        attendanceTime: item.attendanceTime,
        propName: item.propName,
      }));
      setApiData(formattedData);
    }
  };

  const {
    mutate: getListMutate,
    isLoading,
    error,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
  });

  useEffect(() => {
    getListMutate();
  }, [selectedDate]);
  const CustomEvent = ({ event }) => (
    <div>
      <h2 className="text-white text-sm font-semibold">{event.title}</h2>
      {event.attendanceTime && event.propName && (
        <div className="text-xs mt-0.5">
          <div>
            Checkin:{" "}
            {moment(event.attendanceTime, "HH:mm:ss").format("hh:mm A")}
          </div>
          Property:{" "}
          {event.propName.length > 15
            ? event.propName.substring(0, 15) + "..."
            : event.propName || "-"}
        </div>
      )}
    </div>
  );
  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap ">
          <BackWrapper>
            <BackButton onClick={() => navigate(-1)}>
              <IoChevronBackOutline size={20} />
            </BackButton>
            <div>
              <span className="flex items-center">
                {capitalizeFirstLetter(`${tenantName}'s Attendance`)}
              </span>
              <Underline />
            </div>
          </BackWrapper>
        </BoxTitle>
        <div className="flex flex-col justify-end">
          <InputGroup>
            <div className="relative items-center">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="MMMM yyyy"
                showMonthYearPicker
                className="border border-gray-400 p-2 rounded-md w-40 h-10 bg-white cursor-pointer pl-8"
                maxDate={new Date()}
                onFocus={(e) => e.target.blur()}
                showFullMonthYearPicker
                showTwoColumnMonthYearPicker
                onClickOutside={() => setCalendarOpen(false)}
                onSelect={() => setCalendarOpen(false)}
                open={calendarOpen}
                onInputClick={() => setCalendarOpen(true)}
                showPopperArrow={false}
                portalId="root-portal"
                popperClassName="react-datepicker-popper"
              />
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-4 absolute left-2 top-3 text-gray-500"
              />
              <MdKeyboardArrowDown
                className="absolute right-2 top-3 md:block hidden text-gray-500"
                style={{ fontSize: "18px", cursor: "pointer" }}
              />
            </div>
          </InputGroup>
        </div>
      </BoxHead>
      {!error && !isLoading && (
        <Calendar
          localizer={localizer}
          events={apiData}
          startAccessor="start"
          endAccessor="start"
          views={{ month: true }}
          defaultView="month"
          date={moment(selectedDate).startOf("month").toDate()}
          //   tooltipAccessor="tooltip"
          components={{
            // event: CustomEvent,
            toolbar: CustomToolbar,
          }}
          eventPropGetter={(event) => {
            let backgroundColor =
              event.title === "Present" ? "#4CAF50" : "#F44336";
            return {
              style: {
                backgroundColor,
                color: "#fff",
                borderRadius: "4px",
              },
            };
          }}
        />
      )}
      {isLoading && <Loading />}
      {(error || apiData.length === 0) && !isLoading && <NotFoundModel />}
    </BoxContainer>
  );
};
const BackWrapper = tw.div`flex items-center`;
const BackButton = tw.button`hover:bg-gray-200 items-center -mt-1 p-1 rounded-full transition-colors`;
export default TenantAttendance;
